/** @jsx jsx */
import { css, jsx } from "@emotion/react";
import { Tooltip } from "@material-ui/core";
import { BugReport } from "@material-ui/icons";
import { FC } from "react";
import styled, { ThemedCssCreator } from "../../../../config/emotion";
import { useFormattedMsg } from "../../../../hooks/useFormatMsg";

const reportBugButtonCss: ThemedCssCreator = ({ colors }) => css`
  background-color: ${colors.secondaryColor};
  display: flex;
  flex-direction: row;
  align-items: center;
  text-transform: capitalize;
  color: white;
  font-size: 12px;
  border-radius: 25px;
  border: none;
  padding: 6px 7px;

  span {
    margin-right: 5px;
  }
`;

const BugReportIcon = styled(BugReport)`
  font-size: 15px !important;
  color: white;
`;

export type ReportBugButtonProps = {
  onClick: () => void;
};

const ReportBugButton: FC<ReportBugButtonProps> = ({ onClick }) => {
  const tooltipTitle = useFormattedMsg("report_a_bug");
  const buttonString = useFormattedMsg("bugs_overview.modal.report");
  return (
    <Tooltip title={tooltipTitle} placement="top-end">
      <button type="button" onClick={onClick} css={reportBugButtonCss}>
        <span>{buttonString}</span>
        <BugReportIcon />
      </button>
    </Tooltip>
  );
};

export default ReportBugButton;
